import * as React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardTitle: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { children, ...rest } = props;
  return (
    <div css={cardTitleStyle} {...rest}>
      <h3 css={cardTitleTextStyle}>{children}</h3>
    </div>
  );
};

const cardTitleStyle = css`
  align-items: center;
  color: rgb(0, 0, 0);
  display: flex;
  perspective-origin: 165px 56px;
  transform-origin: 165px 56px;
  box-sizing: border-box;
  padding: calc(
      ${space.atom} -
        (${lineHeight.mediumHeadline2} - ${fontSize.mediumHeading}) / 2
    )
    ${space.atom};
`;
const cardTitleTextStyle = css`
  align-self: flex-end;
  display: flex;
  font-size: ${fontSize.mediumHeading};
  line-height: ${lineHeight.mediumHeadline2};
  font-weight: ${fontWeight.bold};
  color: ${textColor.primaryDarkColor};
  overflow: hidden;
  transform-origin: 149px 48px;
  margin: 0;
`;
